module.exports = __webpack_public_path__ + "media/images/social-share-button/delicious-645ddfaca5163af23947fc199fcbb637.svg";